import axios from "axios";
import React, { useState, useEffect } from "react";
import Cookies from "universal-cookie";
import CreaOrganoDireccion from "../Modals/crear/CreaAutoevaluacion/CreaOrganoDireccion";

function Titulo4SeccionA(props) {
  const cookies = new Cookies();
  const [lastDate, setLastDate] = useState(null);
  const [list, setList] = useState([]);

  useEffect(() => {
    cargarDatos();
  }, [props.idSolicitud]);

  const cargarDatos = () => {
    axios({
      method: "get",
      auth: {
        username: "BasicAuth@icontec.org",
        password: "yQLzqmR7eZSuAmQZUqhY",
      },
      url:
        "https://suadesarrollo.azurewebsites.net/api/ObtenerOrganosControlPorSolicitudId?SolicitudId=" +
        props.idSolicitud,
    })
      .then((response) => {
        const data = response.data || [];
        setList(data);

        if (data.length > 0) {
          const lastItem = data[data.length - 1];
          setLastDate(new Date(lastItem.fecha).toLocaleDateString("es-CO"));
        }
      })
      .catch((error) => console.log(error));
  };

  // 🔹 Se ejecuta cuando el hijo crea un registro
  const onRegistroCreado = (nuevo) => {
    setList((prev) => [...prev, nuevo]);

    if (nuevo.fecha) {
      setLastDate(new Date(nuevo.fecha).toLocaleDateString("es-CO"));
    }
  };

  const url = window.location.href;
  const partesURL = url.split("/");
  const nombreRuta = partesURL[partesURL.indexOf("#") + 1];

  return (
    <div className="container-fluid">
      <div className="card shadow mb-4">
        <div className="card-header py-3">
          <h6 className="m-0 font-weight-bold text-primary">GENERALIDADES</h6>
        </div>

        <div className="card-body">
          <center>
            <h6>
              3.1. Describa la fecha de conformación y logros de la Junta
              Directiva o Junta de Accionistas o Junta de Socios o el (los)
              máximo(s) órgano(s) de dirección de la institución.
            </h6>

            {lastDate && (
              <h6 className="font-weight-bold text-primary">
                Fecha: {lastDate}
              </h6>
            )}
          </center>

          {cookies.get("tipo_Usuario") === "2" &&
          nombreRuta === "ProcesoAutoevaluacion" ? (
            <CreaOrganoDireccion
              idSolicitud={props.idSolicitud}
              onRegistroCreado={onRegistroCreado}
            />
          ) : null}

          <hr />

          <div className="table-responsive">
            <table className="table table-bordered">
              <thead>
                <tr>
                  <th>Logro</th>
                </tr>
              </thead>
              <tbody>
                {list.length > 0 ? (
                  list.map((item, index) => (
                    <tr key={index}>
                      <td>{item.logro}</td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td className="text-center">No hay registros</td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Titulo4SeccionA;
